import { render, staticRenderFns } from "./HostSettingsPanel.vue?vue&type=template&id=2624b3ed&scoped=true"
import script from "./HostSettingsPanel.vue?vue&type=script&lang=js"
export * from "./HostSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./HostSettingsPanel.vue?vue&type=style&index=0&id=2624b3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2624b3ed",
  null
  
)

export default component.exports